module.exports = __webpack_public_path__ + "img/bghe1.f9f5ffd0.png";